import { NgModule } from '@angular/core';
import { RouterModule, type Routes } from '@angular/router';
import { SettingsComponent } from '@app/modules/client-management/containers/settings/settings.component';
import { AuthGuard, LoginGuard, RoleGuard } from '@auth';
import { canComponentDeactivateGuard } from '@core';
import { clientsManagementsResolver } from '@ngrx-store';
import { Error404Component } from '@ui';

export const routes: Routes = [
  {
    canActivate: [LoginGuard],
    loadChildren: () => import('@app/modules/auth/auth.module').then(m => m.AuthModule),
    path: '',
  },
  {
    canActivate: [AuthGuard],
    loadChildren: () => import('@app/modules/user-profile/user-profile.module').then(m => m.UserProfileModule),
    path: 'user-profile',
  },
  {
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Dashboard' },
    loadChildren: () => import('@app/modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    path: 'dashboard',
  },
  {
    canActivate: [AuthGuard],
    canDeactivate: [canComponentDeactivateGuard],
    data: { breadcrumb: 'Dashboards' },
    loadComponent: () => import('@dashboards')
      .then(m => m.DashboardPageComponent),
    path: 'dashboards/:dashboardId',
  },
  {
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Devices' },
    loadChildren: () => import('@app/modules/devices/devices.module').then(m => m.DevicesModule),
    path: 'devices',
  },
  {
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Incidents' },
    loadChildren: () => import('@app/modules/incidents/incidents.module').then(m => m.IncidentsModule),
    path: 'incidents',
  },
  {
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Reporting' },
    loadChildren: () => import('@app/modules/reporting/reporting.module').then(m => m.ReportingModule),
    path: 'reporting',
  },
  {
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'UC Monitoring',
    },
    loadChildren: () => import('@app/modules/uc-monitoring/uc-monitoring.module').then(m => m.UcMonitoringModule),
    path: 'call-quality',
  },
  {
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Alerts' },
    loadChildren: () => import('@app/modules/alerts/alerts.module').then((m) => m.AlertsModule),
    path: 'alert-settings',
  },
  {
    canActivate: [AuthGuard],
    data: { breadcrumb: 'MQTT Users' },
    loadChildren: () => import('@app/modules/mqtt-users/mqtt-users.module').then((m) => m.MQTTUsersModule),
    path: 'mqtt-users',
  },
  {
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Client Management' },
    loadChildren: () => import('@app/modules/client-management/client-management.module').then(m => m.ClientManagementModule),
    path: 'client-management',
  },
  {
    canActivate: [AuthGuard, RoleGuard],
    component: SettingsComponent,
    data: {
      activeForAdmin: true,
      breadcrumb: 'Settings',
    },
    path: 'settings',
    resolve: {
      childClientList: clientsManagementsResolver,
    },
  },
  {
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Users Management' },
    loadChildren: () => import('@app/modules/user-management/user-management.module').then(m => m.UserManagementModule),
    path: 'user-management',
  },
  {
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Inventory' },
    loadChildren: () => import('@app/modules/inventory/inventory.module').then(m => m.InventoryModule),
    path: 'inventory',
  },
  {
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Device Management' },
    loadChildren: () => import('@app/modules/device-management/device-management.module').then(m => m.DeviceManagementModule),
    path: 'device-management',
  },
  {
    component: Error404Component,
    path: '**',
    pathMatch: 'full',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule {
}
